import {Component, ViewChild} from '@angular/core';

/**
 * @class RegisterComponent
 * @description The component is used to register agent account
 */
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent {
  public email: string;
  public phoneNumber: string;
  public password: string;

  isLoading: boolean;

  @ViewChild('registerForm') private registerForm: any;

  constructor() {
    this.email = '';
    this.phoneNumber = '';
    this.password = '';
  }

  onSubmit() {
    // this.submitted = true;
    if (this.registerForm.invalid) {
      console.log(this.registerForm.invalid);
      return;
    }
    this.register();
  }

  register() {

  }

}
